/**
 * @file automatically generated from MApp.Data.DatasetType
 */

export enum DatasetType {
    Imagery = 1,
    Vector = 2,
    GeoService = 4,
    Attribute = 8,
    Fusion = 16
}
